// eslint-disable-next-line no-unused-vars, import/prefer-default-export
export const HTTP_PREFIX_PLACEHOLDER = "http://";
